import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NewsCard from '../components/Home/NewsCard';
import Sidebar from '../components/Home/Sidebar';
import { useApp } from '../context/AppContext';

const CategoryPage = () => {
    const { category } = useParams();
    const { articles } = useApp();
    const [categoryArticles, setCategoryArticles] = useState([]);
    const [displayCount, setDisplayCount] = useState(9);

    useEffect(() => {
        // ✅ Convert URL param to possible category formats
        const normalizedCategory = category.toLowerCase();

        // Create an array of possible category matches
        const possibleCategories = [
            normalizedCategory,
            normalizedCategory.replace(/-/g, ' '),        // "ajab-gajab" -> "ajab gajab"
            normalizedCategory.replace(/ /g, '-'),        // "ajab gajab" -> "ajab-gajab"
            normalizedCategory.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), // "ajab-gajab" -> "Ajab Gajab"
            normalizedCategory.charAt(0).toUpperCase() + normalizedCategory.slice(1).replace(/-/g, ' ') // "ajab-gajab" -> "Ajab gajab"
        ];

        // Remove duplicates
        const uniqueCategories = [...new Set(possibleCategories)];

        console.log('Category param:', category);
        console.log('Looking for categories:', uniqueCategories);

        const filtered = articles.filter(a =>
            a.status === 'live' &&
            (uniqueCategories.includes(a.category?.toLowerCase()) ||
                a.category?.toLowerCase() === normalizedCategory ||
                a.section?.toLowerCase() === normalizedCategory ||
                a.section?.toLowerCase() === normalizedCategory.replace(/-/g, ' '))
        );

        console.log('Found articles:', filtered.length);

        setCategoryArticles(filtered);
        setDisplayCount(9);
    }, [category, articles]);

    const capitalize = (str) => {
        // Handle special cases
        if (str === 'ajab-gajab') return 'Ajab Gajab';
        if (str === 'viral') return 'Viral';
        if (str === 'lifestyle') return 'Lifestyle';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const displayArticles = categoryArticles.slice(0, displayCount);

    if (categoryArticles.length === 0 && !articles.length) {
        return (
            <div className="loader" style={{ minHeight: '60vh' }}>
                <div className="loader-spinner"></div>
            </div>
        );
    }

    return (
        <div className="page">
            <div className="two-col">
                <div>
                    <div className="section-title">{capitalize(category)} News</div>

                    {categoryArticles.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px',
                            background: '#fff',
                            borderRadius: '12px'
                        }}>
                            <h3>No articles found in {capitalize(category)} category</h3>
                            <p>Check back later for more content!</p>
                        </div>
                    ) : (
                        <>
                            <div className="three-col">
                                {displayArticles.map(article => (
                                    <NewsCard key={article._id} article={article} />
                                ))}
                            </div>
                            {displayCount < categoryArticles.length && (
                                <div style={{ textAlign: 'center', marginTop: '24px' }}>
                                    <button className="btn btn-outline" onClick={() => setDisplayCount(displayCount + 6)}>
                                        Load More →
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div>
                    <Sidebar articles={articles} />
                </div>
            </div>
        </div>
    );
};

export default CategoryPage;